export default __webpack_public_path__ + "static/media/HistoryBottom.008aac6b.svg";